export const fadeIn = {
  from: { opacity: 0 },
  to: { opacity: 1 },
};

export const fadeOut = {
  from: { opacity: 1 },
  to: { opacity: 0 },
};

export const slideUp = {
  from: { transform: "translateY(0px)" },
  to: { transform: "translateY(-208px)" },
  config: { duration: 2000 },
};

export const slideDown = {
  from: { transform: "translateY(-208px)" },
  to: { transform: "translateY(0px)" },
  config: { duration: 2000 },
};
